export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.admin.staff': 'Staff Management',
  'menu.admin.shift-assignment': 'Shift Assignment',
  'menu.user.login': 'Login',
  'menu.user.register': 'Register',
  'menu.admin.user-management': 'User Management',
  'menu.admin.site-management': 'Site Management',
  'menu.admin.site-details': 'Site Details',
  'menu.admin.incident-management': 'Incident Management',
  'menu.admin.staff-management': 'Staff Management',
  'menu.admin.shift-management': 'Shift Management',
  'menu.admin.staff-leave-management': 'Staff Leave Management',
  'menu.admin.shift-details': 'Shift Details',
  'menu.admin.staff-assignments': 'Staff Assignments',
  'menu.admin.attendance-management': 'Attendance Management',

  'menu.mcp': 'MCP',
  'menu.mcp.flow-builder': 'MCP Flow Builder',
  'menu.mcp.mcp.flow-builder': 'MCP Flow Builder',
  'menu.admin.logistics-hub-management': 'Logistics Hub Management',
  'menu.admin.courier-management': 'Courier Management',
  'menu.admin.driver-management': 'Driver Management',
  'menu.admin.vehicle-management': 'Vehicle Management',
  'menu.admin.container-management': 'Container Management',
  'menu.admin.parcel-management': 'Parcel Management',
  'menu.admin.asset-management': 'Asset Management',
  'menu.admin.tenant-management': 'Tenant Management',
  'menu.admin.public-holiday-management': 'Public Holiday Management',
  'menu.admin.version-management': 'Version Management',
};
